import { RumEvent } from '@datadog/browser-rum';

/** Query values sent unmasked. Only list values the app sets itself, never user input or API data. */
const ALLOWED_QUERY_PARAMS = new Set([
    'step', // application detail step name
    'isEaas', // '0' or '1'
    'vpp' // VPP provider name
]);

/** Keys are kept, so queries can still see that a parameter was set. */
export function scrubQueryValues(url: string): string {
    const [withoutFragment] = url.split('#');
    const queryStart = withoutFragment.indexOf('?');
    if (queryStart === -1) {
        return withoutFragment;
    }

    const scrubbed = new URLSearchParams();
    new URLSearchParams(withoutFragment.slice(queryStart + 1)).forEach((value, key) =>
        scrubbed.append(key, ALLOWED_QUERY_PARAMS.has(key) ? value : '_')
    );
    return `${withoutFragment.slice(0, queryStart)}?${scrubbed.toString()}`;
}

/** Every event type carries `view`, so this runs on all of them. */
export function scrubViewUrls(event: RumEvent): void {
    event.view.url = scrubQueryValues(event.view.url);
    if (event.view.referrer) {
        event.view.referrer = scrubQueryValues(event.view.referrer);
    }
}
